import { useState } from 'react';

// Components
import Form from './views/Form';
import Wellcome from './views/Wellcome';

export default function ContractUS({ setSessionMessage, history, device, typecontract }) {
  const [response, setResponse] = useState({});

  const { accionSiguiente = '', accionSiguienteMensaje = '' } = response;
  return (
    (accionSiguiente === 'FIN' && accionSiguienteMensaje === 'Mensaje Bienvenida...' && (
      <div>
        <Wellcome recordSuccess={response} history={history} typecontract={typecontract} />
      </div>
    )) || (
      <Form
        setResponse={setResponse}
        setSessionMessage={setSessionMessage}
        device={device}
        typecontract={typecontract}
        history={history}
      />
    )
  );
}
